export default __webpack_public_path__ + "static/media/Quiz.1c514e1e.svg";